exports.default = {
  'paiteams': 'PAITEAMS',
  'discover': '发现',
  'home': '首页',
  'conversation': '对话',
  'projects': '项目',
  'assets': '资产',
  'account_settings': '账号设置',
  'my_sub': '我的订阅',
  'upgrade': '升级',
  'upgrade_to_pro': '升级至专业版',
  'language': '语言',
  'theme': '主题',
  'logout': '退出登录',
  'team_invitation': '团队邀请',
  'confirm': '确 定',
  'create_team': '创建团队',
  'cancel': '取 消',
  'join_team': '加入团队',
  'leave_team': '离开团队',
  'confirm_leave_team': '确定要离开当前团队吗？离开后将无法继续访问该团队资源。',
  'leave_team_success': '已离开团队',
  'confirm_logout': '确定退出系统吗？',
  'logout_system': '退出系统',
  'exit': '退出',
  'return_to_agentstore': '返回 AgentStore',
  'exit_management': '退出管理',
  'team_management': '团队管理',
  'organization_info': '组织信息',
  'member_management': '成员管理',
  'team_settings': '团队设置',
  'member_department': '成员部门',
  'member_approval': '成员审批',
  'role_management': '角色管理',
  'limit_management': '限额管理',
  'consumption_records': '消费记录',
  'no_management_permission': '你没有管理权限！',
  'current_team': '当前团队',
  'personal_team': '个人团队',
  'enterprise_team': '企业团队',
  'available_points': '可用积分',
  'light': '浅色',
  'dark': '深色',
  'system': '跟随系统',
  'invite_reward': '邀请奖励',
  'invite_reward_tip': '邀请朋友可获得免费积分',
  'refer_friend': '推荐朋友',
  'bind_invite_code': '填写邀请码',
  'free_credits': '免费积分',
  'contact_us': '联系我们',
  'enterprise_contact': '企微联系',
  'enterprise_dialog_heading': '企业创作，从此协同有序',
  'enterprise_dialog_intro': '面向团队的协作、素材与成员管理，让创作流程更清晰。',
  'enterprise_benefit_collaboration': '团队协作',
  'enterprise_benefit_collaboration_desc': '统一团队创作流程，减少沟通与交接成本。',
  'enterprise_benefit_brand': '品牌规范',
  'enterprise_benefit_brand_desc': '集中管理品牌素材与使用标准。',
  'enterprise_benefit_assets': '素材管理',
  'enterprise_benefit_assets_desc': '团队资产统一沉淀，查找和复用更高效。',
  'enterprise_benefit_flexible': '灵活配置',
  'enterprise_benefit_flexible_desc': '根据团队规模配置用量与服务权益。',
  'enterprise_benefit_members': '成员管理',
  'enterprise_benefit_members_desc': '统一管理团队成员与工作空间。',
  'enterprise_benefit_service': '专属服务',
  'enterprise_benefit_service_desc': '企业顾问协助评估并配置合适方案。',
  'enterprise_service_custom': '按需配置权益',
  'enterprise_service_scale': '支持团队扩展',
  'enterprise_service_advisor': '专属顾问服务',
  'enterprise_advisor_title': '联系企业顾问',
  'enterprise_advisor_desc': '了解企业版方案、团队规模与使用需求，我们会提供专属咨询。',
  'enterprise_qrcode_placeholder': '企微码待补充',
  'enterprise_qrcode_hint': '企微码确认后将在此展示'
}
